import { memo } from "react";

import Input from "@/components/Input/Input";

interface HighlyConfidentialTextFieldEditablePresenterProps {
  /** フィールドID */
  id: string;
  /** フィールド名 */
  name?: string;
  /** 現在の値 */
  value: string;
  /** プレースホルダー */
  placeholder?: string;
  /** 無効化されているかどうか */
  disabled?: boolean;
  /** 読み取り専用かどうか */
  readOnly?: boolean;
  /** 必須かどうか */
  required?: boolean;
  /** エラー状態 */
  error?: boolean;
  /** aria-invalid */
  ariaInvalid?: boolean;
  /** aria-describedby */
  ariaDescribedBy?: string;
  /** テストID */
  testId?: string;
  /** 値変更ハンドラー */
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** フォーカスハンドラー */
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  /** ブラーハンドラー */
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

/**
 * 高機密テキストフィールドの編集可能プレゼンター
 * 責務: 編集可能時のUI表示のみ
 */
export const HighlyConfidentialTextFieldEditablePresenter = memo(
  ({
    id,
    name,
    value,
    placeholder,
    disabled,
    readOnly,
    required,
    error,
    ariaInvalid,
    ariaDescribedBy,
    testId,
    onChange,
    onFocus,
    onBlur,
  }: HighlyConfidentialTextFieldEditablePresenterProps) => {
    return (
      <Input
        id={id}
        name={name}
        type="text"
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        error={error}
        aria-invalid={ariaInvalid}
        aria-describedby={ariaDescribedBy}
        width="100%"
        className="w-full"
        data-testid={testId || "highly-confidential-input-field"}
      />
    );
  },
);

HighlyConfidentialTextFieldEditablePresenter.displayName =
  "HighlyConfidentialTextFieldEditablePresenter";
